import { IntlProvider } from "next-intl";
import App, { AppProps } from "next/app";
import { AppHead } from "../common/components/AppHead";
import { FloatingCTA } from "../common/components/FloatingCTA";
import Footer from "../common/components/Footer";
import { fetchAPI } from "../common/lib/api";
import { LOCALE_OPTIONS } from "../common/lib/api/base";
import { WindowContextProvider } from "../common/lib/hooks/useWindow";
import "../common/styles/globals.scss";
import txt from "../common/translations";

// export const GlobalContext = createContext<Omit<Global, "id">>({
//   created_at: null,
//   siteName: "Spaceship",
//   updated_at: null,
// });

const MyApp = ({ Component, pageProps, router }: AppProps) => {
  const { messages } = pageProps;
  return (
    <IntlProvider messages={messages} locale={router.locale || "en"}>
      <WindowContextProvider>
        <AppHead {...{ router }} />
        <Component {...pageProps} />
        <Footer {...{ router }} />
        <FloatingCTA />
      </WindowContextProvider>
    </IntlProvider>
  );
};

// getInitialProps disables automatic static optimization for pages that don't
// have getStaticProps. So article, category and home pages still get SSG.
// Hopefully we can replace this with getStaticProps once this issue is fixed:
// https://github.com/vercel/next.js/discussions/10949
MyApp.getInitialProps = async (ctx: any) => {
  // Calls page's `getInitialProps` and fills `appProps.pageProps`
  const appProps = await App.getInitialProps(ctx);
  // Fetch global site settings from Strapi
  const global = await fetchAPI("/global");
  // Pass the data to our page via props
  return {
    ...appProps,
    pageProps: { global, messages: txt[ctx.ctx.locale as LOCALE_OPTIONS] },
    locale: "en",
  };
};

export default MyApp;
